import { LitElement, html } from './-global.min.js'

class CollectionProductGrid extends LitElement {
  constructor() {
    super()
  }

  connectedCallback() {
    super.connectedCallback()
    this.restoreScrollItem()
    this._boundCalculate2x2 = this.calculate2x2ImageHeights.bind(this)
    requestAnimationFrame(() => {
      this.calculate2x2ImageHeights()
    })
    window.addEventListener('resize', this._boundCalculate2x2)
  }

  disconnectedCallback() {
    super.disconnectedCallback()
    window.removeEventListener('resize', this._boundCalculate2x2)
  }

  /** Grid is in light DOM (inside container); LitElement querySelector only sees shadow DOM */
  getGrid() {
    const container = this.firstElementChild
    return container?.querySelector('.product-grid')
  }

  /**
   * Set row height from product cards so the 2x2 doesn't stretch rows (no overflow).
   * Set 2x2 image height = 2 × product-grid__item height + row-gap so image flushes with cards.
   * Use a product from row 3+ for height when 2x2 exists (row 1–2 items are stretched by 2x2).
   */
  calculate2x2ImageHeights() {
    const grid = this.getGrid()
    if (!grid) return
    const isMobile = window.innerWidth < 990

    const productItems = grid.querySelectorAll(
      '.product-grid__item:not(:has(.collection-featured-content))'
    )
    const productItem = productItems[0]
    if (!productItem) return
    const productMedia = productItem.querySelector('.product-card__media')
    if (!productMedia) return

    const itemHeight = productItem.offsetHeight

    const rowGap = parseFloat(getComputedStyle(grid).rowGap) || 0
    const imageHeight = productMedia.offsetHeight + rowGap + itemHeight

    grid
      .querySelectorAll('.collection-featured-content--2x2')
      .forEach((card) => {
        const imageEl = card.querySelector(
          '.collection-featured-content__image'
        )
        if (!imageEl) return
        const current = parseInt(imageEl.style.height, 10)
        if (current !== imageHeight) imageEl.style.height = `${imageHeight}px`
        // remove height from imageEl if isMobile
        if (isMobile) imageEl.style.height = ''
      })
  }

  restoreScrollItem() {
    const anchorId = location.hash
    if (!anchorId) return

    const productCardEl = document.querySelector(anchorId)
    if (!productCardEl) return

    if ('scrollRestoration' in history) {
      history.scrollRestoration = 'manual'

      document.addEventListener('beforeunload', () => {
        history.scrollRestoration = 'auto'
      })
    }

    setTimeout(() => {
      productCardEl.scrollIntoView({
        behavior: 'smooth',
      })
    }, 250)
  }

  render() {
    return html`<slot></slot>`
  }
}

customElements.define('collection-product-grid', CollectionProductGrid)
